module.exports = __webpack_public_path__ + "static/media/bgmodalblue.37ff3f39.PNG";